import RouteCheckerTo from '@/views/route-checker';
import SelectiveProcessView from './selective-process.view.vue'

export default [
  {
    path: '/selective-process',
    component: SelectiveProcessView,
    name: 'Processo Seletivo',
    beforeEnter: RouteCheckerTo.hasAccessSelectiveProcess,
  },
];
